import Searchbar from "@/components/Searchbar";
import searchMagic from "@/icons/search_magic.svg";
import { dispatchCustomEvent } from "@/helpers/triggerAnalyticsEvent";


function  setURLParams(input: string) {
  const urlParams = new URLSearchParams(window.location.search);
  urlParams.set("expanded",input);
  urlParams.delete("q");
  history.pushState(
    null,
    "",
    `${window.location.pathname}?${decodeURIComponent(urlParams.toString())}`
  );
}

const Subheader = ({
  handlePrompt = () => {},
  onSearchSubmit = () => {},
} 
: {
  handlePrompt?: (query: string) => void;
  onSearchSubmit?: (query: boolean) => void;
}) => {
   

  const handleClick = () => {
    dispatchCustomEvent({
      dataObject: "body-subheader",
      dataType: "link",
      dataReason: "Joyhunt_get_more_inspiration_ideas",
    });
    setURLParams("true#examples")
    onSearchSubmit(false);
  };

  return (
    <div className="h-[212px] sm:h-[198px] lg:h-[148px] w-full bg-[#F5F5F5] mt-[8px]">
      <div className=" sm:max-w-[768px] md:max-w-[978px] lg:max-w-[1280px] xl:max-w-[1360px] h-full my-auto mx-[8px] sm:mx-auto sm:mb-[36px] pt-[24px] md:pt-0 md:mb-0 flex flex-col md:flex-row md:items-center md:justify-between">
        <Searchbar showSamples handlePrompt={handlePrompt}/>
        <button
          className="flex gap-1 items-center mr-4 text-syfGreen mt-[24px] md:mt-[56px] self-end md:self-auto h-[24px] cursor-pointer syfclickevent hover:shadow-[0px_4px_32px_0px_#00000014] hover:bg-white py-6 px-3 rounded-[8px] hover:animate-bgFade"
          onClick={handleClick}
          id="more-inspiration"
          data-object="body-subheader"
          data-type="link"
          data-reason="Joyhunt_get_more_inspiration_ideas"
          tabIndex={0}
        >
    <img src={searchMagic} alt="" className="w-[19px] h-[20px]" />
          <span className="text-[16px] leading-[24px] text-right font-bold">
            Get more inspiration ideas
          </span>
        </button>
      </div>
    </div>
  );
};

export default Subheader;
